import { createWebHistory, createRouter } from 'vue-router';

const router = createRouter({
    history: createWebHistory(),

    routes: [
        {
            path: '/',
            name: 'home',
            component: () => import('./components/NewHome.vue'),
            children: [
                {
                    path: 'order',
                    name: 'order',
                    components: { order: () => import('./components/Order/OrderDialog.vue') }
                },
            ]

        },

    ],
});

export default router;
